module.exports = __webpack_public_path__ + "static/media/jonathanGillette.bcfbc1b8.jpg";